import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import { loadLightStompunkterIfNeeded } from './loadLightStompunkter'

export const toggleFilter = createActionCreator(actions.TOGGLE_FILTER, 'filter')

export function changeFilter(filter) {
    return function(dispatch, getState) {
        dispatch(toggleFilter(filter))
        dispatch(loadLightStompunkterIfNeeded())
    }
}



// WEBPACK FOOTER //
// ./src/actionCreators/filter.js